import { DecideApprovalRequestSchema, DecideApprovalResponseSchema } from './decide-approval.schema';
export const decideApprovalContract = {
    method: 'POST',
    path: '/api/v2/approval/:id/decide',
    description: 'Approve or reject an approval as a named reviewer',
    requestSchema: DecideApprovalRequestSchema,
    responseSchema: DecideApprovalResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Not pending, already decided, or a rejection without reason',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a reviewer of this approval',
            404: 'Approval not found'
        }
    }
};

//# sourceMappingURL=decide-approval.contract.js.map